import { useThemeContext } from "../components/theme/ThemeContext";
import { Theme } from "../constant/Theme";
import Select, { GroupBase, Props } from "react-select";

const light = {
  control: (base: any) => ({
    ...base,
    backgroundColor: "white",
    color: "black",
  }),
  menu: (base: any) => ({ ...base, backgroundColor: "white", color: "black" }),
  option: (base: any, { isFocused, isDisabled }: any) => ({
    ...base,
    backgroundColor:
      isDisabled ? "#c7c3c3"
      : isFocused ? "#f0f0f0"
      : "white",
    color: isDisabled ? "#5e5e5e" : "black",
    fontStyle: isDisabled ? "italic" : "normal",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "black",
  }),
  input: (base: any) => ({
    ...base,
    color: "black",
  }),
};

const dark = {
  control: (base: any) => ({
    ...base,
    backgroundColor: "black",
    color: "white",
  }),
  menu: (base: any) => ({ ...base, backgroundColor: "black", color: "white" }),
  option: (base: any, { isFocused, isDisabled }: any) => ({
    ...base,
    backgroundColor:
      isDisabled ? "#2b2b2b"
      : isFocused ? "#a3a3a3"
      : "black",
    color: isDisabled ? "#c7c7c7" : "white",
    fontStyle: isDisabled ? "italic" : "normal",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "white",
  }),
  input: (base: any) => ({
    ...base,
    color: "white",
  }),
  multiValue: (base: any) => ({
    ...base,
    backgroundColor: "#3a3a3a",
  }),
  multiValueLabel: (base: any) => ({
    ...base,
    color: "white",
  }),
  multiValueRemove: (base: any) => ({
    ...base,
    color: "white",
    ":hover": {
      backgroundColor: "#555555",
      color: "white",
    },
  }),
};

function ThemedSelect<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Props<Option, IsMulti, Group>) {
  const { theme } = useThemeContext();

  return <Select styles={theme == Theme.LIGHT ? light : dark} {...props} />;
}

export default ThemedSelect;
